import type { FC, ReactNode } from 'react';

/**
 * Table cell holding a value and, separated by a divider, the action that
 * produces it — so the trigger stays visible without scrolling to a far-right
 * Actions column.
 *
 * Used by the Applications `Flows calculated` cell
 * (`{calculated}/{total}` │ refresh button). The Flows `Calculation status` cell does
 * *not* use this: it shows either its count or its trigger, never both.
 *
 * Both slots are nodes so this stays presentational — `value` is the value as the
 * OAS column renders it (links and all), `action` is the trigger.
 */
export const AimTableValueWithActionCell: FC<{
  value: ReactNode;
  action: ReactNode;
}> = ({ value, action }) => (
  <span className='flex items-center justify-end gap-2xs'>
    <span className='truncate'>{value}</span>
    <span className='self-stretch border-l border-solid border-divider' />
    {action}
  </span>
);
